import {useEffect, useState} from 'react';
import queryString from 'query-string';
import { Auth } from 'aws-amplify';
import { clearStorage } from '../../utils/auth';

const Logout = ({history}) => {
  const [loading, setLoading] = useState(false);
  const search = queryString.parse(history.location.search);
  const isAdmin = 'adm' in search;
  console.log(history);

  useEffect(() => {
    const loadLogout = async () => {
      try {
        setLoading(true)
        await Auth.signOut({
          global: true,
        });

        await clearStorage();

        if (isAdmin) {
            history.push(`/login?adm=true`);
        } else {
            history.push(`/login`);
        }
        setLoading(false)
      } catch (e) {
        clearStorage();
      }
    };

    loadLogout()
  }, [history, isAdmin]);

  if(loading){
    return <div/>
  }

  return null;
};

export default Logout;
